// extracted by mini-css-extract-plugin
export default {"root":"AiSummary-desktop-module__root___zZXL9"};